/* eslint-disable */

export default `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>
<head>
	<meta http-equiv="content-type" content="text/html; charset=windows-1252"/>
	<title></title>
	<meta name="generator" content="LibreOffice 7.1.2.2 (Windows)"/>
	<meta name="created" content="2022-01-03T18:54:00"/>
	<meta name="changed" content="2022-01-05T20:36:18.739000000"/>
	<meta name="AppVersion" content="16.0000"/>
	<style type="text/css">
		@page { size: 21cm 29.7cm; margin-left: 3.25cm; margin-right: 3cm; margin-top: 1.25cm; margin-bottom: 2.5cm }
		p { margin-bottom: 0.25cm; direction: ltr; line-height: 80%; text-align: left; orphans: 2; widows: 2; background: transparent }
		a:link { color: #0000ff; text-decoration: underline }
		a:visited { color: #800000; so-language: zxx; text-decoration: underline }
	</style>
</head>
<body lang="pt-BR" link="#0000ff" vlink="#800000" dir="ltr">
<div title="header"><p align="center" style="margin-bottom: 1.15cm; border: none; padding: 0cm; line-height: 100%">
	<br/>

	</p>
</div>
<p align="center" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; display: flex; justify-content: center">
<font size="3" style="font-size: 12pt"><span style="font-variant: small-caps"><font face="Tahoma, serif"><u><b>PARA VOCÊ ENTENDER MELHOR O QUE FAZEMOS COM AS SUAS INFORMAÇÕES</b></u></font></span></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Fizemos o m&aacute;ximo para explicar de forma clara e simples quais dados pessoais
precisaremos de voc&ecirc; e o que vamos fazer com cada um deles. Por isso,
separamos abaixo os pontos mais importantes, que tamb&eacute;m podem ser lidos de
forma bem completa e detalhada nas nossas
 </font><font face="Tahoma, serif"><u><b>Pol&iacute;ticas de Privacidade</b></u></font><font face="Tahoma, serif">. 	</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Al&eacute;m disso, estamos sempre dispon&iacute;veis para tirar qualquer d&uacute;vida que voc&ecirc;
tenha:</font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><ul style="font-size: 12pt">
<li>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
<font face="Tahoma, serif">
<font size="3" style="font-size: 12pt">
Usu&aacute;rio M&eacute;dico: por meio do e-mail <u>comercial@synsaude.com.br</u> 
ou <u> contato@synsaude.com.br</u>, no endere&ccedil;o Rua Miquerinos, 01,
Edif&iacute;cio Golden Tower, Sala 906, Bairro Renascen&ccedil;a, S&atilde;o Lu&iacute;s - MA,
Brasil, CEP: 65.075-038 ou pelo n&uacute;mero de telefone ou WhatsApp
(98) 99173-8018 e (11) 96796-1848.
</font></font>
</p>
</li>

<li>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
<font face="Tahoma, serif">
<font size="3" style="font-size: 12pt">
Demais Usu&aacute;rios: por meio do e-mail <u style="color:blue"> orcamento@synsaude.com.br</u>
ou <u>contato@synsaude.com.br</u>, no endere&ccedil;o Rua Miquerinos, 01,
Edif&iacute;cio Golden Tower, Sala 906, Bairro Renascen&ccedil;a, S&atilde;o Lu&iacute;s - MA,
Brasil, CEP: 65.075-038 ou pelo n&uacute;mero de telefone ou WhatsApp
(98) 99229-3099 e (98) 99224-9283.
</font></font>
</p>
</li>
</ul>
</font>
</font>
</p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>1)
Como faremos a segurança de seus dados?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> Para garantir a sua seguran&ccedil;a, seus dados pessoais s&atilde;o transferidos de
forma criptografada e armazenados em servidores <i>cloud </i>(em nuvem)
fornecidos pela empresa <u style="color:blue">Microsoft Azure</u> - respons&aacute;vel pelo
armazenamento e seguran&ccedil;a (indicamos fortemente que voc&ecirc; leia os
Termos &amp; Contrato de Servi&ccedil;o da Microsoft Azure, principalmente as
Pol&iacute;ticas de Privacidade), cujo acesso &eacute; restrito. Al&eacute;m disso, utilizamos
firewalls e certificados de seguran&ccedil;a, dispondo de uma variedade de
tecnologias e procedimentos de seguran&ccedil;a para ajudar a proteger as
informa&ccedil;&otilde;es dos Usu&aacute;rios.<b> <u>Com isso, essa empresa passa a ter
acesso aos seus dados, somente para armazen&aacute;-los e proteg&ecirc;-
los, assim que voc&ecirc; os fornece na Syn Sa&uacute;de</u></b>. Se voc&ecirc; tiver algum
problema com isso, pedimos que n&atilde;o continue utilizando a plataforma.</font>
</font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>2)
Como faremos a segurança e processamento dos seus dados de
pagamento?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 
Para o processamento das informa&ccedil;&otilde;es referentes aos pagamentos, os
seus dados ser&atilde;o enviados via API e trafegados pela plataforma
independente Stone, que &eacute; a institui&ccedil;&atilde;o respons&aacute;vel pelo processamento
dos pagamentos. N&oacute;s utilizamos essas plataformas terceirizadas para que

Esta Plataforma pertence &agrave; SYN SOLU&Ccedil;&Atilde;O EM SA&Uacute;DE LTDA.

CNPJ/ME n.o 38.312.622/0001-28.

eles possam garantir a seguran&ccedil;a nas transa&ccedil;&otilde;es financeiras, j&aacute; que
sozinhos n&atilde;o conseguir&iacute;amos.
</font>
</font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>3)
Quais dados voc&#234; precisa nos informar ao se cadastrar na
plataforma?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 
Quando os Usu&#225;rios se cadastraram na plataforma iremos pedir as
seguintes informa&#231;&#245;es:
</font>
</font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 
<ul style="font-size: 12pt">
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
Usu&#225;rio M&#233;dico: Nome completo, CPF, e-mail, telefone, CRM/CRO,
UF, especialidade(s), dados banc&#225;rios.</p></li>
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
4.1.2. Usu&#225;rio Secret&#225;ria: Nome completo, CPF, e-mail e telefone.</p></li>
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
4.1.3. Usu&#225;rio Hospital: Nome fantasia, Raz&#227;o social, CNPJ, UF,
Taxa de comercializa&#231;&#227;o de OPME (caso haja), setor, dados
banc&#225;rios, dados do usu&#225;rio respons&#225;vel pelas cota&#231;&#245;es como:
Nome completo, CPF, cargo, e-mail e telefone com WhatsApp.</p></li>
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
4.1.4. Usu&#225;rio Fornecedor de OPME: Nome fantasia, Raz&#227;o social,
CNPJ, nome do respons&#225;vel, CPF, telefone e e-mail do respons&#225;vel,
especialidades que fornecem materiais, dados banc&#225;rios.</p></li>
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
4.1.5. Usu&#225;rio Operacional: Nome completo, CPF, telefone, data de
nascimento, e-mail.</p></li>
<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%"> 
4.1.6. Usu&#225;rio Paciente: Nome completo, CPF, data de nascimento,
sexo, e-mail, comorbidade e dados banc&#225;rios.</p></li>
</ul> 
</font>
</font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>4)
Com quem compartilhamos seus dados pessoais?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
N&#243;s iremos compartilhar os seus dados pessoais com as empresas
referenciadas nestas pol&#237;ticas e internamente apenas com as pessoas
estritamente necess&#225;rias para possibilitar a presta&#231;&#227;o do nosso servi&#231;o,
como Customer Support e S&#243;cios. Salvo nos casos citados, em caso de
consentimento legal do titular dos dados pessoais e por for&#231;a de ordem
judicial ou determina&#231;&#227;o legal, n&#243;s n&#227;o iremos compartilhar seus dados
com terceiros.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>5)Seus registros de acesso ser&#227;o coletados?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
Quando voc&#234; entra na nossa plataforma, colhemos seus registros de
acesso, ou seja, conjunto de informa&#231;&#245;es referentes &#224; data e hora de uso
de uma determinada aplica&#231;&#227;o de internet a partir de um determinado
endere&#231;o IP. Estas informa&#231;&#245;es ser&#227;o mantidas pela <b>Syn</b>, sob sigilo, em
ambiente controlado e de seguran&#231;a, pelo prazo m&#237;nimo de 06 (seis)
meses, nos termos da Lei n.o 12.965/2014, e artigo 7o, II, da Lei n.o
13.709/18.
</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>6)
Dados pessoais ser&#227;o coletados de forma indireta (sem
	preenchimento de formul&#225;rios)?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
Al&#233;m disso, coletamos sua localiza&#231;&#227;o e informa&#231;&#245;es de forma indireta via
navega&#231;&#227;o e cookies para rastrear endere&#231;o de IP, p&#225;gina visitada, tipo
e/ou vers&#227;o do navegador, sistema operacional usado, hor&#225;rio de acesso,
para oferecer a melhor experi&#234;ncia de uso da plataforma.
</font></font></p>



<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>7)
Registros de comunica&#231;&#245;es ser&#227;o armazenados?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
N&#243;s vamos armazenar todas as conversas que voc&#234; tiver conosco em
nossos canais de comunica&#231;&#227;o, pois isso ir&#225; melhorar o seu atendimento
e torn&#225;-lo mais eficiente. Sem esse hist&#243;rico, provavelmente todas as
vezes que voc&#234; utilizasse a plataforma teria que repetir o que j&#225; nos
passou anteriormente.
</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>8)
Como seus dados ser&#227;o tratados?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
Todos os seus dados s&#227;o tratados com finalidades espec&#237;ficas e de acordo
com a Lei Geral de Prote&#231;&#227;o de Dados Pessoais. Todas essas informa&#231;&#245;es
est&#227;o descritas em uma tabela, para facilitar a sua visualiza&#231;&#227;o, nas nossas
Pol&#237;ticas de Privacidade.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>9)
Quais s&#227;o seus direitos?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
Mesmo que voc&#234; j&#225; tenha nos fornecido seus dados pessoais, voc&#234; possui
total direito de, a qualquer momento: confirmar a exist&#234;ncia de tratamento
dos seus dados; acessar os seus dados; corrigir os seus dados; tornar
an&#244;nimo os dados; bloquear ou eliminar os dados desnecess&#225;rios,
excessivos ou tratados em desconformidade com a Lei; pedir a
portabilidade dos dados a outro fornecedor; eliminar dados, exceto
aqueles exigidos por lei; obter informa&#231;&#227;o sobre quem a <b>Syn</b> realizou uso
compartilhado de dados; obter informa&#231;&#227;o sobre a possibilidade de n&#227;o
fornecer consentimento e sobre as consequ&#234;ncias da negativa; e voltar
atr&#225;s e revogar o seu consentimento.
</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>10)
Essas condi&#231;&#245;es poder&#227;o mudar?</b></u></font></font></p>

<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">	 
Nossa Pol&#237;tica de Privacidade poder&#225; mudar, mas voc&#234; sempre poder&#225;
acessar a vers&#227;o mais atualizada na nossa plataforma. Al&#233;m disso, se
formos realizar alguma a&#231;&#227;o que a lei exija sua autoriza&#231;&#227;o, voc&#234; receber&#225;
um aviso antes para poder aceitar ou recusar.
</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>11) Qual é o conteúdo das Políticas de Privacidade?</b></u></font></font></p>
<p align="justify" style="margin-left: 0.75cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">A Política de Privacidade a seguir está dividida da seguinte forma para
facilitar o seu acesso à informação:</font></font></p>
<ol type="a">
	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	a) Data de Disponibilização do Texto;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	b) Explicação dos Termos Técnicos ou em Língua Estrangeira;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	c) Privacidade do Usuário e Operadores de Dados Terceirizados;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	d) Coleta de Dados;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	e) Tratamento de Dados Pessoais;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	f) Compartilhamento dos Dados Pessoais dos Usuários;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	g) Cancelamento da Plataforma, de Contas de Acesso e Exclusão de Dados;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	h) Direitos do Titular dos Dados Pessoais;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	i) Segurança;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	j) Mudanças na Política de Privacidade;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	k) Encarregado e Disposições Gerais;
	</font><font face="Tahoma, serif"></font></font></p>

	<p align="justify" style="margin-bottom: 0cm; line-height: 0%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
	l) Contato.
	</font><font face="Tahoma, serif"></font></font></p>
</ol>

<p align="right" style="margin-left: 1.27cm; margin-top: 0.1cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><b>Syn.</b></font></font></p>

<p align="center" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; display: flex; justify-content: center">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>POL&#205;TICAS DE PRIVACIDADE</b></u></font></font>
</p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff"><a name="_heading=h.gjdgxs"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u> Antes de acessar a plataforma da<b> Syn</b>, &#233; importante que voc&#234; leia, entenda e
aceite de forma livre, inequ&#237;voca e informada estas Pol&#237;ticas de Privacidade.</u>
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
Esta Plataforma, cujo nome &#233; <b>Syn Sa&#250;de &#233;</b> de propriedade, mantida e operada
por <b>SYN SOLU&#199;&#195;O EM SA&#218;DE LTDA</b>, pessoa jur&#237;dica de direito privado inscrita
no CNPJ/ME sob o n.o 38.312.622/0001-28, Rua Miquerinos, 01, Edif&#237;cio Golden
Tower, Sala 906, Bairro Renascen&#231;a, S&#227;o Lu&#237;s - MA, Brasil, CEP: 65.075-038.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">O presente documento visa prestar informa&#231;&#245;es sobre a coleta, utiliza&#231;&#227;o,
tratamento e armazenamento dos dados fornecidos pelos Usu&#225;rios e est&#225; em
conformidade com a Lei n.o 12.965/2014 (Marco Civil da Internet) e com a Lei
n.o 13.709/18 (Lei Geral de Prote&#231;&#227;o de Dados).
</font><font face="Tahoma, serif">

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>1.
DATA DE DISPONIBILIZA&Ccedil;&Atilde;O DO TEXTO</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">1.1.
A presente vers&atilde;o deste documento foi disponibilizada em:
27/12/2022.</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><span style="font-variant: small-caps"><font face="Tahoma, serif"><u><b>2.
EXPLICA&Ccedil;&Atilde;O DOS TERMOS T&Eacute;CNICOS OU EM L&Iacute;NGUA
ESTRANGEIRA</b></u></font></span></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; border: none; padding: 0cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">2.1.
Abaixo est&atilde;o dispostos os significados das nomenclaturas
t&eacute;cnicas e termos na l&iacute;ngua inglesa.</font></font></p>
<ul style="font-size: 12pt">
	<li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Controlador: Pessoa natural ou jur&#237;dica, de direito p&#250;blico ou privado, a
  quem competem as decis&#245;es referentes ao tratamento de dados pessoais;
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  <i>Cookies</i>: Pequenos arquivos de texto que ficam gravados no computador
  do internauta e podem ser recuperados pelo site que o enviou durante a
  navega&#231;&#227;o. S&#227;o utilizados principalmente para identificar e armazenar
  informa&#231;&#245;es sobre os visitantes.
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Criptografia: Conjunto de princ&#237;pios e t&#233;cnicas para cifrar a escrita, torn&#225;-
  la inintelig&#237;vel para os que n&#227;o tenham acesso &#224;s conven&#231;&#245;es combinadas
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Dado pessoal: Informa&#231;&#227;o relacionada a pessoa natural identificada ou
  identific&#225;vel;
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Dado pessoal sens&#237;vel: Dado pessoal sobre origem racial ou &#233;tnica,
  convic&#231;&#227;o religiosa, opini&#227;o pol&#237;tica, filia&#231;&#227;o a sindicato ou a organiza&#231;&#227;o
  de car&#225;ter religioso, filos&#243;fico ou pol&#237;tico, dado referente &#224; sa&#250;de ou &#224; vida
  sexual, dado gen&#233;tico ou biom&#233;trico, quando vinculado a uma pessoa
  natural;
  </font></font>
  </p>
  <li >
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Encarregado: Pessoa indicada pelo controlador e operador para atuar
  como canal de comunica&#231;&#227;o entre o controlador, os titulares dos dados e
  a Autoridade Nacional de Prote&#231;&#227;o de Dados (ANPD).
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Gateway de Pagamento: Tecnologia que permite que o pagamento seja
  feito de forma digital, servindo de intermediadora entre o banco, o
  consumidor, o fornecedor e a operadora de cart&#227;o de cr&#233;dito.
  </font></font>
  </p>
  <li >
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  IP (ou <i>Internet Protocol</i>): Identifica&#231;&#227;o &#250;nica para cada computador
  conectado a uma rede.
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm;
   line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Operador: Pessoa natural ou jur&#237;dica, de direito p&#250;blico ou privado, que
  realiza o tratamento de dados pessoais em nome do controlador;
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Tratamento de dados: Toda opera&#231;&#227;o realizada com dados pessoais, como
  as que se referem a coleta, produ&#231;&#227;o, recep&#231;&#227;o, classifica&#231;&#227;o, utiliza&#231;&#227;o,
  acesso, reprodu&#231;&#227;o, transmiss&#227;o, distribui&#231;&#227;o, processamento,
  arquivamento, armazenamento, elimina&#231;&#227;o, avalia&#231;&#227;o ou controle da
  informa&#231;&#227;o, modifica&#231;&#227;o, comunica&#231;&#227;o, transfer&#234;ncia, difus&#227;o ou
  extra&#231;&#227;o.
  </font></font>
  </p>
</ul>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">2.2.
S&atilde;o os tipos de Usu&aacute;rios da Plataforma:</font></font></p>
<ul style="font-size: 12pt">
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	M&eacute;dico: Aquele que cria pacotes cir&uacute;rgicos, solicita
	cirurgias, aprova propostas, acompanha o status de suas solicita&ccedil;&otilde;es
	de cirurgias, compartilha pacotes de cirurgias com colegas e
	hospitais e convida outros m&eacute;dicos para serem parceiros da<b>
	SYN</b>.</font></font></p>

	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio Secret&aacute;ria: Aquele que tem autoriza&ccedil;&atilde;o de um (ou mais de
		um) Usu&aacute;rio M&eacute;dico para ter acesso &agrave;s mesmas informa&ccedil;&otilde;es que esse
		Usu&aacute;rio tem, podendo criar, editar e acompanhar procedimentos. Por&eacute;m,
		este Usu&aacute;rio n&atilde;o pode aprovar propostas ou excluir solicita&ccedil;&otilde;es.</font></font></p>

	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Hospital: Aquele que responde a solicita&ccedil;&atilde;o de cota&ccedil;&atilde;o
	de cirurgias, avalia&ccedil;&atilde;o pr&eacute;-anest&eacute;sica,
	banco de sangue e que possui a op&ccedil;&atilde;o de recusar
	solicita&ccedil;&atilde;o de or&ccedil;amento. </font></font>
	</p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Fornecedor de OPME: Aquele que responde a solicita&ccedil;&atilde;o
	de cota&ccedil;&atilde;o de &Oacute;rtese, Pr&oacute;tese e
	Materiais Especiais (OPME) feita pelo Usu&aacute;rio M&eacute;dico.</font></font></p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Usu&aacute;rio
	Cliente: Aquele que recebe as propostas de or&ccedil;amentos
	solicitadas pelo usu&aacute;rio m&eacute;dico, acompanha os status
	da solicita&ccedil;&atilde;o e aprova ou reprova a(s) proposta(s) e realiza pagamentos.</font><font color="#d99594"><font face="Tahoma, serif">.</font></font></font></p>
	<li><p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">Estes
	Usu&aacute;rios, em conjunto, ser&atilde;o chamados apenas de
	Usu&aacute;rios.</font></font></p>
</ul>
</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height:
 130%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>
3.PRIVACIDADE DO USU&#193;RIO E OPERADORES DE DADOS
TERCEIRIZADOS</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%; background: #ffffff"><a name="_heading=h.30j0zll"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.1. Proteger sua privacidade &eacute; muito importante para n&oacute;s. Seus dados s&atilde;o
transferidos de forma criptografada e armazenados em banco de dados
hospedado em servidor <i>cloud</i> (em nuvem) fornecido pela empresa terceirizada
<u style="color:blue">Microsoft Azure</u> - respons&aacute;vel pelo armazenamento e seguran&ccedil;a, cujo acesso &eacute;
restrito. Al&eacute;m disso, utilizamos firewalls e certificados de seguran&ccedil;a, dispondo de
uma variedade de tecnologias e procedimentos de seguran&ccedil;a para ajudar a
proteger as informa&ccedil;&otilde;es dos Usu&aacute;rios.</font></font></p>


<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.1.1.
</font><font face="Tahoma, serif">Essa empresa &eacute; independente e n&atilde;o possui rela&ccedil;&atilde;o com o presente
texto. Sendo assim, recomendamos que voc&ecirc; tamb&eacute;m leia os Termos de
Uso e Pol&iacute;ticas de Privacidade dessa plataforma e veja se concorda com
todas as disposi&ccedil;&otilde;es, antes de utilizar nossos servi&ccedil;os. </u></font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 3.1.2.
</font><font face="Tahoma, serif">Para o processamento das informa&ccedil;&otilde;es referentes aos pagamentos,
os seus dados ser&atilde;o enviados via API e trafegados pela plataforma
independente <u style="color:blue">Stone</u>, que &eacute; a institui&ccedil;&atilde;o respons&aacute;vel pelo processamento
dos pagamentos. N&oacute;s n&atilde;o teremos acesso aos seus dados banc&aacute;rios e
utilizamos essas plataformas terceirizadas para que eles possam garantir a
seguran&ccedil;a nas transa&ccedil;&otilde;es financeiras, j&aacute; que sozinhos n&atilde;o conseguir&iacute;amos.
Tamb&eacute;m recomendamos que leia os Termos Gerais de Contrata&ccedil;&atilde;o de
Produtos e Servi&ccedil;os e Aviso de Privacidade da <u style="color:blue">Stone</u>, antes de realizar
pagamentos.</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>



<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">3.2. O servidor utilizado pela <b>Syn </b>que &eacute; munido de mecanismos aptos a
assegurar a seguran&ccedil;a de seus dados est&aacute; localizado no Brasil e tem o objetivo
de prestar os servi&ccedil;os contratados de forma segura e eficaz, conforme a Lei n.o
13.709/18.</font></font></p>


<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
3.3. Todos os registros de acesso, conjunto de informa&ccedil;&otilde;es referentes &agrave; data e
hora de uso de uma determinada aplica&ccedil;&atilde;o de internet a partir de um
determinado endere&ccedil;o IP, ser&atilde;o mantidos pelo <b>Syn</b>, sob sigilo, em ambiente
controlado e de seguran&ccedil;a, pelo prazo m&iacute;nimo de 06 (seis) meses, nos termos
da Lei n.o 12.965/2014, e artigo 7o, II, da Lei n.o 13.709/18.</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
3.4. O Usu&aacute;rio deve se responsabilizar e se declarar exclusivo respons&aacute;vel por
todas as a&ccedil;&otilde;es, bem como por todas as informa&ccedil;&otilde;es e a veracidade do conte&uacute;do
que inserir na plataforma.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height:
 130%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>
4.COLETA DE DADOS</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.1. Dados fornecidos pelo Usu&aacute;rio M&eacute;dico: Nome completo, CPF, e-mail,
telefone, CRM/CRO, UF, especialidade(s), dados banc&aacute;rios.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.2. Dados fornecidos pelo Usu&aacute;rio Secret&aacute;ria: Nome completo, CPF, e-mail e
telefone.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.3. Dados fornecidos pelo Usu&aacute;rio Hospital: Nome fantasia, Raz&atilde;o social, CNPJ,
UF, Taxa de comercializa&ccedil;&atilde;o de OPME (caso haja), setor, dados banc&aacute;rios, dados
do usu&aacute;rio respons&aacute;vel pelas cota&ccedil;&otilde;es como: Nome completo, CPF, cargo, e-mail
e telefone com WhatsApp.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.4. Dados fornecidos pelo Usu&aacute;rio Fornecedor de OPME: Nome fantasia, Raz&atilde;o
social, CNPJ, nome do respons&aacute;vel, CPF, telefone e e-mail do respons&aacute;vel,
especialidades que fornecem materiais, dados banc&aacute;rios.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.5. Dados fornecidos pelo Usu&aacute;rio Operacional: Nome completo, CPF, telefone,
data de nascimento, e-mail.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.6. Dados fornecidos pelo Usu&aacute;rio Paciente: Nome completo, CPF, data
de nascimento, e-mail e comorbidade.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.7. <u>Informa&ccedil;&otilde;es que coletamos de forma indireta</u>: Al&eacute;m dos registros de acesso,
coletamos sua localiza&ccedil;&atilde;o e informa&ccedil;&otilde;es de forma indireta via navega&ccedil;&atilde;o e
cookies para rastrear endere&ccedil;o de IP, p&aacute;gina visitada, tipo e/ou vers&atilde;o do
navegador, sistema operacional usado, hor&aacute;rio de acesso, para oferecer a melhor
experi&ecirc;ncia de uso da plataforma.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
4.8. <u>Hist&oacute;rico de contato</u>: A <b>Syn</b> armazena informa&ccedil;&otilde;es a respeito de todas as
intera&ccedil;&otilde;es j&aacute; realizadas entre os Usu&aacute;rios por meio da plataforma, como
mensagens em e-mails, contatos telef&ocirc;nicos, chat online e upload de arquivos,
pois isso ir&aacute; melhorar o seu atendimento e torn&aacute;-lo mais eficiente. Sem esse
hist&oacute;rico, provavelmente todas as vezes que voc&ecirc; utilizasse a plataforma teria
que repetir o que j&aacute; nos passou anteriormente.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height:
 130%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>
5. TRATAMENTO DE DADOS PESSOAIS</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
5.1. Ao aceitar a presente pol&iacute;tica de privacidade, o Usu&aacute;rio compreende que a
plataforma realiza o tratamento de seus dados pessoais, conforme informa&ccedil;&otilde;es
apresentadas a seguir:
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm;">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
<table style="width: 100%;margin-top: 0.35cm; 
margin-bottom: 0.35cm; line-height: 80%;font-size: 12pt;border: 1px solid #dddddd">
  <tr>
    <th style="width:30%; border: 1px solid #dddddd; text-align: left; padding: 8px;">Tipo de Dado Pessoal</th>
	<th style="background-color: #dddddd;border: 1px solid #dddddd; text-align: left; padding: 8px;">Base Legal</th>
    <th style="background-color: #dddddd;border: 1px solid #dddddd; text-align: left; padding: 8px;">Finalidade</th>
  </tr>
  <tr>
    <td style="font-weight: bold;font-size: 12pt; border: 1px solid #dddddd; text-align: left; padding: 8px;">Nome</td>
    <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Necess&aacute;rio para a
	execu&ccedil;&atilde;o de contrato
	ou de procedimentos
	preliminares
	relacionados a contrato
	do qual seja parte o
	titular, a pedido do
	titular dos dados (Art.
	7o, V, Lei n.o
	13.709/2018). </td>
	<td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Usado para identifica&ccedil;&atilde;o do
	Usu&aacute;rio. Trata-se de dado
	pessoal essencial para que
	seja poss&iacute;vel entrar em
	contato com o Usu&aacute;rio para
	atender &agrave;s suas solicita&ccedil;&otilde;es
	e fornecer respostas
	direcionadas.</td>
  </tr>
  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;">Telefone e e-mail</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Necess&aacute;rio para a
  execu&ccedil;&atilde;o de contrato
  ou de procedimentos
  preliminares
  relacionados a contrato
  do qual seja parte o
  titular, a pedido do
  titular dos dados (Art.
  7o, V, Lei n.o
  13.709/2018).
  Necess&aacute;rio para o
  cumprimento do
  leg&iacute;timo interesse do
  controlador (Art. 7, IX,
  Lei n.o 13.709/2018).
  </td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado para login e
  valida&ccedil;&atilde;o de cadastro na
  plataforma, assim como
  meio de comunica&ccedil;&atilde;o com
  o Usu&aacute;rio, para contatos e
  intera&ccedil;&otilde;es ao longo da
  jornada de uso da
  plataforma.
  Utilizado para a&ccedil;&otilde;es de
  marketing, notifica&ccedil;&otilde;es no
  programa e novidades,
  informar sobre mudan&ccedil;as
  em nossos termos, servi&ccedil;os
  ou pol&iacute;ticas.</td>
  </tr>


  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;">CPF</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Cumprimento de
  obriga&ccedil;&atilde;o legal ou
  regulat&oacute;ria pelo
  controlador (Art. 7o, II,
  Lei n.o 13.709/2018).
  Necess&aacute;rio para a
  execu&ccedil;&atilde;o de contrato
  ou de procedimentos
  preliminares
  relacionados a contrato
  do qual seja parte o
  titular, a pedido do
  titular dos dados (Art.
  7o, V, Lei n.o
  13.709/2018).</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado para emiss&atilde;o de
  nota fiscal pelos servi&ccedil;os
  prestados pela plataforma.
  Utilizamos como login na
  plataforma.</td>
  </tr>



  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Dados banc&aacute;rios</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Necess&aacute;rio para a
  execu&ccedil;&atilde;o de contrato
  ou de procedimentos
  preliminares
  relacionados a contrato
  do qual seja parte o titular, a pedido do
  titular dos dados (Art.
  7o, V, Lei n.o
  13.709/2018).</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado pelo gateway de
  pagamento para que possa
  processar as opera&ccedil;&otilde;es
  financeiras e trazer mais
  seguran&ccedil;a.</td>
  </tr>



  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Profiss&atilde;o e
  Identifica&ccedil;&atilde;o
  Profissional
  </td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Cumprimento de
  obriga&ccedil;&atilde;o legal ou
  regulat&oacute;ria pelo
  controlador (Art. 7o, II,
  Lei n.o 13.709/2018).</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado para validar que o
  Usu&aacute;rio M&eacute;dico realmente
  &eacute; um profissional da sa&uacute;de
  e est&aacute; apto a realizar
  atividades relacionadas &agrave;
  sa&uacute;de.</td>
  </tr>

  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Localiza&ccedil;&atilde;o</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%"> Necess&aacute;rio para o
  cumprimento do
  leg&iacute;timo interesse do
  controlador. (Art. 7, IX,
  Lei n.o 13.709/2018).</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado para garantir a
  funcionalidade dos nossos
  servi&ccedil;os.</td>
  </tr>


  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Lista de pacientes
  recomendados</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Quando o titular ou seu
  respons&aacute;vel legal
  consentir, de forma
  espec&iacute;fica e destacada,
  para finalidades
  espec&iacute;ficas (Art. 11, I,
  Lei n.o 13.709/2018).</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Utilizado para criar um
  c&oacute;digo para que o Usu&aacute;rio
  Paciente seja associado ao
  Usu&aacute;rio M&eacute;dico.</td>
  </tr>


  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Registros de acesso</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Cumprimento de
  obriga&ccedil;&atilde;o legal ou
  regulat&oacute;ria pelo
  controlador (Art. 7o, II,
  Lei n.o 13.709/2018).</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Obedi&ecirc;ncia ao artigo 15 da
  Lei n.o 12.965/2014, que
  imp&otilde;e o dever da <b>Syn</b> de
  manter os respectivos
  registros de acesso a
  aplica&ccedil;&otilde;es de internet, sob
  sigilo, em ambiente
  controlado e de seguran&ccedil;a, 
  pelo prazo de 6 (seis)
  meses.</td>
  </tr>



  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Comorbidade do
  Usu&aacute;rio Paciente</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Exerc&iacute;cio regular de
  direitos, inclusive em
  contrato e em processo
  judicial, administrativo
  e arbitral. Art. 11, II, d,
  Lei n.o 13.709/2018).</td>
  <td style="font-weight: bold;background-color: rgb(166 166 166);font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Tornar o or&ccedil;amento
  previs&iacute;vel, pois em alguns
  casos, o Usu&aacute;rio Paciente
  com comorbidade precisa
  de atendimento especial.</td>
  </tr>



  <tr>
  <td style="font-weight: bold; border: 1px solid #dddddd; text-align: left; padding: 8px;line-height: 150%">Data de Nascimento
  do Usu&aacute;rio Paciente
  e do Usu&aacute;rio M&eacute;dico</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">Necess&aacute;rio para a
  execu&ccedil;&atilde;o de contrato
  ou de procedimentos
  preliminares
  relacionados a contrato
  do qual seja parte o
  titular, a pedido do
  titular dos dados (Art.
  7o, V, Lei n.o
  13.709/2018).</td>
  <td style="background-color: #dddddd;font-weight: bold;font-size: 12pt ;margin-top: 0.35cm; margin-bottom: 0.35cm;border: 1px solid #dddddd; line-height: 150%">A data de nascimento do
  Usu&aacute;rio Paciente &eacute; usada
  para calcular a idade do
  Usu&aacute;rio Paciente, visto que
  tal informa&ccedil;&atilde;o &eacute; relevante
  para a elabora&ccedil;&atilde;o dos
  or&ccedil;amentos.</td>
  </tr>
</table>
</font></font>
</p>



<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>6. COMPARTILHAMENTO DOS DADOS DOS USU&Aacute;RIOS
</b></u></font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.3znysh7"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
6.1. Poder&atilde;o ter acesso interno &agrave;s informa&ccedil;&otilde;es dos Usu&aacute;rios apenas pessoas
estritamente necess&aacute;rias para a presta&ccedil;&atilde;o do servi&ccedil;o, como Customer Support e
S&oacute;cios.
 </font></font></p>

 <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.3znysh7"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
6.2. Os dados dos Usu&aacute;rios ser&atilde;o compartilhados pela <b>Syn</b> com as seguintes
empresas e para as seguintes finalidades:
 </font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.2.1. <u style="color:blue">Microsoft Azure</u>: uma vez que os dados pessoais ficam armazenados
em seus servidores;</font></font></p>

<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.94fvkp2ixaux"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.2.2. <u style="color:blue">Stone</u>: uma vez que os dados pessoais ficam armazenados em seus
servidores;</font></font>
</p>
<p align="justify" style="margin-left: 1.25cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%"><a name="_heading=h.94fvkp2ixaux"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.2.3. A partir do momento que estas empresas tiverem acesso a estes
dados, se tornar&atilde;o respons&aacute;veis pela seguran&ccedil;a, tratamento e

compartilhamento adequado dessas informa&ccedil;&otilde;es,<u> n&atilde;o podendo divulg&aacute;-
las para outras finalidades, em desconformidade com a legisla&ccedil;&atilde;o vigente

ou com estas Pol&iacute;ticas de Privacidade, sob pena de responderem por todas
as puni&ccedil;&otilde;es, em especial as de natureza c&iacute;vel, criminal e as aplicadas pela
Autoridade Nacional de Prote&ccedil;&atilde;o de Dados</u>.</font></font>
</p>

<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.kz97zzxxhx3y"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">6.3. Salvo nos casos citados, em caso de <u></u>consentimento legal do titular dos dados
pessoais e por for&ccedil;a de ordem judicial ou determina&ccedil;&atilde;o legal, n&oacute;s n&atilde;o iremos
compartilhar seus dados com terceiros.
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>7. CANCELAMENTO DA PLATAFORMA, DE CONTAS DE ACESSO E
EXCLUS&Atilde;O DE DADOS
</b></u></font></font></p>
<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.kz97zzxxhx3y"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
7.1. Cancelamento de contas de acesso pela <b>Syn</b>: A <b>Syn</b> poder&aacute;, a seu exclusivo
crit&eacute;rio, bloquear, restringir, desabilitar ou impedir o acesso de qualquer Usu&aacute;rio
&agrave; plataforma sempre que for detectada uma conduta inadequada.
</font></font>
</p>
<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.kz97zzxxhx3y"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
7.2. Cancelamento dos servi&ccedil;os pelo Usu&aacute;rio: Para cancelar os servi&ccedil;os o Usu&aacute;rio
dever&aacute; enviar um e-mail para contato@synsaude.com.br ou pelo n&uacute;mero de
telefone ou WhatsApp (98) 99229-3099 e (98) 99224-9283.
</font></font>
</p>

<p align="justify" style="margin-bottom: 0cm; line-height: 80%"><a name="_heading=h.kz97zzxxhx3y"></a>
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
7.3.<u><b> Exclus&atilde;o de dados: No momento do cancelamento da conta,
quando finda a finalidade de tratamento de dados ou diante de
solicita&ccedil;&atilde;o, o Usu&aacute;rio ter&aacute; todos os seus dados deletados
imediatamente e permanentemente da plataforma, exceto os dados
cuja manuten&ccedil;&atilde;o seja obrigat&oacute;ria por lei ou regula&ccedil;&atilde;o, os dados
necess&aacute;rios para o exerc&iacute;cio regular de direitos em processo judicial,
administrativo ou arbitral, como os registros de acesso (conjunto de
informa&ccedil;&otilde;es referentes &agrave; data e hora de uso de uma determinada
aplica&ccedil;&atilde;o de internet a partir de um determinado endere&ccedil;o IP), que
ser&atilde;o mantidos, sob sigilo, em ambiente controlado e de seguran&ccedil;a,
pelo prazo de 6 (seis) meses, nos termos da Lei n.o 12.965/2014 e com
a base legal do art. 7, II, da Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais.</b></u>
</font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>8. DIREITOS DO TITULAR DOS DADOS PESSOAIS
</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"> <font face="Tahoma, serif">
8.1. O titular de dados pessoais tem direito a obter do controlador, em rela&ccedil;&atilde;o
aos dados por ele tratados, a qualquer momento e mediante requisi&ccedil;&atilde;o:
</font></font>
</p>
<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.1. Confirma&ccedil;&atilde;o da exist&ecirc;ncia de tratamento de dados;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.2. Acesso aos dados;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.3. Corre&ccedil;&atilde;o de dados incompletos, inexatos ou desatualizados;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.4. Anonimiza&ccedil;&atilde;o, bloqueio ou elimina&ccedil;&atilde;o de dados desnecess&aacute;rios,
excessivos ou tratados em desconformidade com o disposto na Lei n.o
13.709/2018;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>


<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.5. Portabilidade dos dados a outro fornecedor de servi&ccedil;o ou produto,
mediante requisi&ccedil;&atilde;o expressa, de acordo com a regulamenta&ccedil;&atilde;o da
autoridade nacional, observados os segredos comercial e industrial;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>


<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.6. Elimina&ccedil;&atilde;o dos dados tratados com o consentimento do titular,
exceto nas hip&oacute;teses previstas na Lei n.o 13.709/2018;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.7. Informa&ccedil;&atilde;o das entidades p&uacute;blicas e privadas com as quais o
controlador realizou uso compartilhado de dados;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.8. Informa&ccedil;&atilde;o sobre a possibilidade de n&atilde;o fornecer consentimento e
sobre as consequ&ecirc;ncias da negativa;
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-left: 1.27cm; margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
8.1.9. Revoga&ccedil;&atilde;o do consentimento.
</font><font face="Tahoma, serif"><u><b>
</b></u></font></font>
</p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>9. SEGURAN&Ccedil;A
</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">9.1. A <b>Syn</b> tem o compromisso de preservar a estabilidade, seguran&ccedil;a e
funcionalidade da plataforma, por meio de medidas t&eacute;cnicas compat&iacute;veis com os
padr&otilde;es internacionais e pelo est&iacute;mulo ao uso de boas pr&aacute;ticas. Todavia nenhum
servi&ccedil;o dispon&iacute;vel na internet possui total garantia contra invas&otilde;es ilegais. Em
casos em que terceiros n&atilde;o autorizados invadam o sistema de forma il&iacute;cita, a <b>Syn</b>
diligenciar&aacute; da melhor forma para encontrar o respons&aacute;vel pela atua&ccedil;&atilde;o il&iacute;cita,
mas n&atilde;o se responsabiliza pelos danos por eles causados.</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>10. MUDAN&Ccedil;AS NA POL&Iacute;TICA DE PRIVACIDADE
</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
10.1. A Syn poder&aacute; unilateralmente adicionar e/ou modificar qualquer cl&aacute;usula
contida nestas Pol&iacute;ticas de Privacidade. A vers&atilde;o atualizada valer&aacute; para o uso
da plataforma realizada a partir de sua publica&ccedil;&atilde;o. A continuidade de acesso ou
utiliza&ccedil;&atilde;o do site, depois da divulga&ccedil;&atilde;o, confirmar&aacute; a vig&ecirc;ncia das novas
Pol&iacute;ticas de Privacidade pelos Usu&aacute;rios.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
10.2. Caso a mudan&ccedil;a efetuada necessite de <u>consentimento do Usu&aacute;rio</u>, ser&aacute;
apresentada a op&ccedil;&atilde;o de aceitar de forma livre, inequ&iacute;voca e informada o novo
texto ou recus&aacute;-lo.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">
10.3. Caso o Usu&aacute;rio n&atilde;o esteja de acordo com a altera&ccedil;&atilde;o, poder&aacute; n&atilde;o fornecer
consentimento para atos espec&iacute;ficos ou poder&aacute; rescindir totalmente seu v&iacute;nculo
com a <b>Syn</b>. Essa rescis&atilde;o n&atilde;o eximir&aacute;, no entanto, o Usu&aacute;rio de cumprir com
todas as obriga&ccedil;&otilde;es assumidas sob as vers&otilde;es precedentes das Pol&iacute;ticas de
Privacidade.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>11. ENCARREGADO E DISPOSI&Ccedil;&Otilde;ES GERAIS
</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 11.1. A <b>Syn</b> indica como encarregado o Sr. Jos&eacute; Rubem Ferreira Vasconcellos,
com endere&ccedil;o eletr&ocirc;nico ti@synsaude.com.br, nos termos do art. 41 da Lei Geral
de Prote&ccedil;&atilde;o de Dados, para aceitar reclama&ccedil;&otilde;es e comunica&ccedil;&otilde;es dos titulares e
da Autoridade Nacional de Prote&ccedil;&atilde;o de Dados, prestar esclarecimentos e adotar
provid&ecirc;ncias.
</font></font></p>
<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"> 11.2. A <b>Syn</b> disp&otilde;e de um texto espec&iacute;fico para regular a licen&ccedil;a de uso, os
direitos, deveres, garantias e disposi&ccedil;&otilde;es gerais: os Termos de Uso. Todos esses
documentos integram inseparavelmente estas Pol&iacute;ticas de Privacidade.
</font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif"><u><b>12. CONTATO
</b></u></font></font></p>

<p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 80%">
<font size="3" style="font-size: 12pt"><font face="Tahoma, serif">12.1. A <b>Syn</b> disponibiliza os seguintes canais para receber todas as comunica&ccedil;&otilde;es
que os Usu&aacute;rios desejarem fazer:</font></font>
</p>
<ul style="font-size: 12pt">
	<li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Usu&aacute;rio M&eacute;dico: por meio do e-mail comercial@synsaude.com.br
ou contato@synsaude.com.br, no endere&ccedil;o Rua Miquerinos, 01,
Edif&iacute;cio Golden Tower, Sala 906, Bairro Renascen&ccedil;a, S&atilde;o Lu&iacute;s - MA,
Brasil, CEP: 65.075-038 ou pelo n&uacute;mero de telefone ou WhatsApp
(98) 99173-8018 e (11) 96796-1848. 
  </font></font>
  </p>
  <li>
  <p align="justify" style="margin-top: 0.35cm; margin-bottom: 0.35cm; line-height: 130%">
	<font face="Tahoma, serif">
  <font size="3" style="font-size: 12pt">
  Demais Usu&aacute;rios: por meio do e-mail orcamento@synsaude.com.br
ou contato@synsaude.com.br, no endere&ccedil;o Rua Miquerinos, 01,
Edif&iacute;cio Golden Tower, Sala 906, Bairro Renascen&ccedil;a, S&atilde;o Lu&iacute;s - MA,
Brasil, CEP: 65.075-038 ou pelo n&uacute;mero de telefone ou WhatsApp
(98) 99229-3099 e (98) 99224-9283.
  </font></font>
  </p>
</ul>



</body>
</html>
`
